(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["exclusive-offers-block"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__eoCopyInit) return;
    window.__eoCopyInit = true;

    function fallbackCopy(text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
    }

    function copyCode(btn) {
      var code = btn.getAttribute('data-code') || '';
      if (!code) return;

      var doCopy;
      if (navigator.clipboard && window.isSecureContext) {
        doCopy = navigator.clipboard.writeText(code).catch(function () {
          fallbackCopy(code);
        });
      } else {
        fallbackCopy(code);
        doCopy = Promise.resolve();
      }

      doCopy.then(function () {
        var label = btn.querySelector('[data-eo-copy-label]');
        var wrap = btn.closest('[data-eo-block]');
        var live = wrap ? wrap.querySelector('[data-eo-live]') : null;

        if (btn.__eoResetTimer) clearTimeout(btn.__eoResetTimer);
        btn.classList.add('is-copied');
        if (label) label.textContent = 'Copied!';
        if (live) live.textContent = 'Discount code ' + code + ' copied to clipboard';

        btn.__eoResetTimer = setTimeout(function () {
          btn.classList.remove('is-copied');
          if (label) label.textContent = code;
        }, 1600);
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-eo-copy-code]');
      if (!btn) return;
      e.preventDefault();
      copyCode(btn);
    });

    function updateDots(slider) {
      var wrap = slider.closest('[data-eo-block]');
      var dots = wrap ? wrap.querySelectorAll('[data-eo-dots] .eo-dot') : [];
      if (!dots.length) return;
      var firstCard = slider.firstElementChild;
      var cardWidth = firstCard ? (firstCard.getBoundingClientRect().width + 10) : slider.clientWidth;
      if (!cardWidth) return;
      var index = Math.round(slider.scrollLeft / cardWidth);
      index = Math.max(0, Math.min(index, dots.length - 1));
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
      }
    }

    var scrollRaf = null;
    document.addEventListener('scroll', function (e) {
      var slider = e.target;
      if (!slider || !slider.hasAttribute || !slider.hasAttribute('data-eo-slider')) return;
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(function () { updateDots(slider); });
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smart-addons-block"] && !Shopify.designMode) return;
  try {
    /* ============================================================
     Smart Add-ons — behavior script.
     - Vanilla JS, no external libraries.
     - Uses EVENT DELEGATION on `document` for all toggle/variant
       interactions, and reads selection state live from the DOM
       (never a stale in-memory cache) — required because this
       theme's <product-rerender> component can replace the block's
       HTML at any time.
     - Cart integration patches window.fetch to merge selected
       add-ons into any call to /cart/add.js (JSON or FormData
       bodies), then refreshes the cart-drawer section's INNER
       content (never the drawer element itself) via the Section
       Rendering API so it doesn't show stale/optimistic content
       after the merge, without disturbing the drawer's own
       open/close state or animation.
     ============================================================ */
  (function () {
    'use strict';

    if (window.__smartAddonsInit) return;
    window.__smartAddonsInit = true;

    var skipAddonMergeOnce = false; // set right before OUR OWN fetch calls, so the patch below doesn't double-merge them

    function showError(message) {
      window.alert(message); // eslint-disable-line no-alert
    }

    /* ------------------------------------------------------------
       Live DOM helpers — always re-query, never cache node refs.
       ------------------------------------------------------------ */
    function getAllAddonCards() {
      return Array.prototype.slice.call(document.querySelectorAll('[data-smart-addons] [data-addon-card]'));
    }

    function getAddonQuantity(card) {
      var qtyInput = card.querySelector('[data-addon-qty-input]');
      if (!qtyInput) return 1;
      var qty = parseInt(qtyInput.value, 10);
      if (!qty || qty < 1) qty = 1;
      return qty;
    }

    function getSelectedAddonItems() {
      return getAllAddonCards()
        .filter(function (card) { return card.classList.contains('is-selected'); })
        .map(function (card) {
          var id = parseInt(card.getAttribute('data-variant-id'), 10);
          return { id: id, quantity: getAddonQuantity(card) };
        })
        .filter(function (item) { return !!item.id; });
    }

    function hasUnavailableSelected() {
      return getAllAddonCards().some(function (card) {
        return card.classList.contains('is-selected') && card.getAttribute('data-available') !== 'true';
      });
    }

    function resetAddonQuantity(card) {
      var qtyInput = card.querySelector('[data-addon-qty-input]');
      if (qtyInput) qtyInput.value = '1';
    }

    function clearAllSelections() {
      getAllAddonCards().forEach(function (card) {
        resetAddonQuantity(card);
        if (!card.classList.contains('is-selected')) return;
        card.classList.remove('is-selected');
        var toggle = card.querySelector('[data-addon-toggle]');
        if (!toggle) return;
        if (toggle.type === 'checkbox') toggle.checked = false;
        else toggle.setAttribute('aria-checked', 'false');
      });
    }

    function syncCard(toggle) {
      var card = toggle.closest('[data-addon-card]');
      if (!card) return;
      var isOn = toggle.type === 'checkbox' ? toggle.checked : toggle.getAttribute('aria-checked') === 'true';
      card.classList.toggle('is-selected', isOn);
      if (!isOn) resetAddonQuantity(card);
    }

    /* ------------------------------------------------------------
       Custom variant listbox (replaces a native <select> so we can
       show per-option price / compare-at price / a checkmark on the
       current selection / "Sold out" labels — content a native
       <select> cannot render). Only one listbox is ever open at a
       time; it closes on outside click, Escape, or after a
       selection is made.
       ------------------------------------------------------------ */
    function closeAllVariantListboxes(exceptListbox) {
      document.querySelectorAll('[data-addon-variant-listbox]').forEach(function (lb) {
        if (lb === exceptListbox) return;
        if (lb.hidden) return;
        lb.hidden = true;
        var wrap = lb.closest('[data-addon-variant-picker]');
        var trigger = wrap && wrap.querySelector('[data-addon-variant-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    function toggleVariantListbox(trigger) {
      var wrap = trigger.closest('[data-addon-variant-picker]');
      if (!wrap) return;
      var listbox = wrap.querySelector('[data-addon-variant-listbox]');
      if (!listbox) return;
      var isOpen = !listbox.hidden;
      closeAllVariantListboxes(isOpen ? null : listbox);
      listbox.hidden = isOpen;
      trigger.setAttribute('aria-expanded', String(!isOpen));
    }

    function selectVariantOption(optionEl) {
      if (optionEl.getAttribute('aria-disabled') === 'true') return;
      var wrap = optionEl.closest('[data-addon-variant-picker]');
      var card = optionEl.closest('[data-addon-card]');
      if (!wrap || !card) return;

      var listbox = wrap.querySelector('[data-addon-variant-listbox]');
      var trigger = wrap.querySelector('[data-addon-variant-trigger]');

      if (listbox) {
        Array.prototype.slice.call(listbox.querySelectorAll('[data-addon-variant-option]')).forEach(function (li) {
          var selected = li === optionEl;
          li.classList.toggle('is-selected', selected);
          li.setAttribute('aria-selected', selected ? 'true' : 'false');
        });
      }

      var newVariantId = optionEl.getAttribute('data-variant-id');
      var newAvailable = optionEl.getAttribute('data-available') === 'true';
      var newPrice = optionEl.getAttribute('data-price');
      var newTitle = optionEl.getAttribute('data-title') || '';

      if (trigger) {
        var labelEl = trigger.querySelector('[data-addon-variant-trigger-label]');
        if (labelEl) labelEl.textContent = newTitle;
      }

      var toggle = card.querySelector('[data-addon-toggle]');
      var wasSelected = card.classList.contains('is-selected');

      card.setAttribute('data-variant-id', newVariantId);
      card.setAttribute('data-available', String(newAvailable));
      card.setAttribute('data-price', newPrice);

      // NOTE: price/compare-at strings come from Shopify's `money` filter,
      // which some shops configure to return HTML (e.g. a wrapping <span
      // class="money">). Use innerHTML (not textContent) so that HTML is
      // rendered instead of shown as literal escaped tags.
      var priceEl = card.querySelector('[data-addon-price]');
      var compareEl = card.querySelector('[data-addon-compare-price]');
      var discountEl = card.querySelector('[data-addon-discount]');
      if (priceEl) priceEl.innerHTML = optionEl.getAttribute('data-price-formatted') || '';
      if (compareEl) {
        var compareAt = parseFloat(optionEl.getAttribute('data-compare-at') || '0');
        var price = parseFloat(newPrice || '0');
        if (compareAt > price) {
          compareEl.innerHTML = optionEl.getAttribute('data-compare-at-formatted') || '';
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.setAttribute('hidden', '');
        }
      }
      if (discountEl) {
        var discountText = optionEl.getAttribute('data-discount-text') || '';
        if (discountText) {
          discountEl.textContent = discountText;
          discountEl.removeAttribute('hidden');
        } else {
          discountEl.setAttribute('hidden', '');
        }
      }

      if (toggle) {
        if (newAvailable) {
          toggle.removeAttribute('disabled');
          toggle.removeAttribute('aria-disabled');
        } else {
          toggle.setAttribute('disabled', 'disabled');
          toggle.setAttribute('aria-disabled', 'true');
        }
        if (wasSelected && !newAvailable) {
          if (toggle.type === 'checkbox') toggle.checked = false;
          else toggle.setAttribute('aria-checked', 'false');
          card.classList.remove('is-selected');
        }
      }

      var qtyInput = card.querySelector('[data-addon-qty-input]');
      if (qtyInput) {
        var newMax = parseInt(optionEl.getAttribute('data-max-quantity'), 10);
        if (newMax > 0) {
          qtyInput.max = String(newMax);
          if (parseInt(qtyInput.value, 10) > newMax) qtyInput.value = String(newMax);
        }
      }

      if (listbox) listbox.hidden = true;
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    }

    /* ------------------------------------------------------------
       Event delegation — bound once on document, survives any
       replacement of the block's own DOM nodes.
       ------------------------------------------------------------ */
    document.addEventListener('click', function (e) {
      var variantTrigger = e.target.closest && e.target.closest('[data-addon-variant-trigger]');
      if (variantTrigger) {
        e.preventDefault();
        toggleVariantListbox(variantTrigger);
        return;
      }

      var variantOption = e.target.closest && e.target.closest('[data-addon-variant-option]');
      if (variantOption) {
        e.preventDefault();
        selectVariantOption(variantOption);
        return;
      }

      if (!(e.target.closest && e.target.closest('[data-addon-variant-picker]'))) {
        closeAllVariantListboxes(null);
      }

      var toggle = e.target.closest && e.target.closest('[data-addon-toggle]');
      if (!toggle || toggle.hasAttribute('disabled')) return;
      if (toggle.getAttribute('role') !== 'switch') return; // checkbox variant handled via 'change' below
      var checked = toggle.getAttribute('aria-checked') === 'true';
      toggle.setAttribute('aria-checked', String(!checked));
      syncCard(toggle);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        closeAllVariantListboxes(null);
      }
    });

    document.addEventListener('change', function (e) {
      var checkboxToggle = e.target.closest && e.target.closest('[data-addon-toggle]');
      if (checkboxToggle && checkboxToggle.type === 'checkbox') {
        syncCard(checkboxToggle);
      }
    });

    // Converts a FormData payload from Shopify's single-item product-form
    // submission into the { id, quantity, properties } shape used by the
    // JSON /cart/add.js API, so it can be merged with additional items.
    function formDataToCartPayload(fd) {
      var obj = {};
      var props = null;
      var entries = typeof fd.entries === 'function' ? Array.from(fd.entries()) : [];
      for (var i = 0; i < entries.length; i++) {
        var key = entries[i][0];
        var val = entries[i][1];
        var propMatch = key.match(/^properties\[(.+)\]$/);
        if (propMatch) {
          if (!props) props = {};
          props[propMatch[1]] = val;
        } else if (key === 'id') {
          obj.id = isNaN(val) ? val : parseInt(val, 10);
        } else if (key === 'quantity') {
          obj.quantity = parseInt(val, 10) || 1;
        } else if (key === 'selling_plan') {
          obj.selling_plan = val;
        }
      }
      if (props) obj.properties = props;
      if (!obj.id) return null;
      return obj;
    }

    // Re-fetches the cart-drawer / cart-notification section(s) via
    // Shopify's Section Rendering API and swaps in fresh content — but
    // ONLY via innerHTML on nodes matched by id, never by replacing the
    // live section wrapper or the drawer element itself. Replacing the
    // live element (e.g. via outerHTML) would destroy and recreate the
    // drawer's custom element instance, losing its open/closed state and
    // any in-flight CSS transition, which causes a visible open-then-
    // close "blink" instead of the theme's normal auto-open behavior.
    function refreshCartDrawerSections() {
      try {
        var sectionEls = Array.prototype.slice.call(document.querySelectorAll('[id^="shopify-section-"]'))
          .filter(function (el) { return /cart[-_]?drawer/i.test(el.id) || /cart[-_]?notification/i.test(el.id); });
        sectionEls.forEach(function (el) {
          var sectionId = el.id.replace(/^shopify-section-/, '');
          var url = window.location.pathname + '?sections=' + encodeURIComponent(sectionId);
          fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var html = data[sectionId];
              if (!html) return;
              var temp = document.createElement('div');
              temp.innerHTML = html;
              var liveNodes = el.querySelectorAll('[id]');
              liveNodes.forEach(function (liveNode) {
                if (!liveNode.id) return;
                var freshNode;
                try {
                  freshNode = temp.querySelector('#' + CSS.escape(liveNode.id));
                } catch (e) {
                  freshNode = null;
                }
                if (freshNode && freshNode.tagName === liveNode.tagName) {
                  liveNode.innerHTML = freshNode.innerHTML;
                }
              });
            })
            .catch(function () {});
        });
      } catch (e) {
        // Never let a drawer-refresh failure affect the actual cart contents.
      }
    }

    /* ------------------------------------------------------------
       Global fetch patch: merges selected add-ons into any request
       to /cart/add.js, regardless of what triggered it and
       regardless of whether the body is JSON or FormData.
       ------------------------------------------------------------ */
    var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
    if (nativeFetch) {
      window.fetch = function (input, init) {
        var didMerge = false;
        try {
          if (skipAddonMergeOnce) {
            skipAddonMergeOnce = false;
          } else {
            var url = typeof input === 'string' ? input : (input && input.url) || '';
            var isCartAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
            if (isCartAdd && init && init.body) {
              if (hasUnavailableSelected()) {
                showError('One of the selected add-ons is no longer available and was not added.');
              }
              var addonItems = getSelectedAddonItems();
              if (addonItems.length) {
                var bodyObj = null;
                if (typeof init.body === 'string') {
                  try {
                    bodyObj = JSON.parse(init.body);
                  } catch (e) {
                    bodyObj = null;
                  }
                } else if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
                  bodyObj = formDataToCartPayload(init.body);
                }
                if (bodyObj) {
                  if (Array.isArray(bodyObj.items)) {
                    bodyObj.items = bodyObj.items.concat(addonItems);
                  } else if (bodyObj.id) {
                    var mainEntry = { id: bodyObj.id, quantity: bodyObj.quantity || 1 };
                    if (bodyObj.properties) mainEntry.properties = bodyObj.properties;
                    if (bodyObj.selling_plan) mainEntry.selling_plan = bodyObj.selling_plan;
                    bodyObj = { items: [mainEntry].concat(addonItems) };
                  }
                  var newHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };
                  try {
                    if (init.headers) {
                      if (typeof Headers !== 'undefined' && init.headers instanceof Headers) {
                        init.headers.forEach(function (v, k) { newHeaders[k] = v; });
                      } else {
                        Object.assign(newHeaders, init.headers);
                      }
                    }
                  } catch (e) {}
                  newHeaders['Content-Type'] = 'application/json';
                  init = Object.assign({}, init, {
                    body: JSON.stringify(bodyObj),
                    headers: newHeaders
                  });
                  clearAllSelections();
                  didMerge = true;
                }
              }
            }
          }
        } catch (e) {
          // Never let this patch break the site's real add-to-cart call.
        }
        var result = nativeFetch(input, init);
        if (didMerge) {
          result = result.then(function (res) {
            if (res && res.ok) {
              setTimeout(refreshCartDrawerSections, 30);
            }
            return res;
          });
        }
        return result;
      };
    }

    /* ------------------------------------------------------------
       Accelerated checkout (Shop Pay / PayPal / etc.) fallback.
       Re-applied via MutationObserver so it survives the block's
       HTML being replaced by <product-rerender> or similar.
       ------------------------------------------------------------ */
    function findProductForm(root) {
      var container = (root && root.closest && root.closest('product-rerender')) || document;
      var forms = container.querySelectorAll('form[action*="/cart/add"], form[is="product-form"]');
      for (var i = 0; i < forms.length; i++) {
        var form = forms[i];
        if (form.closest('[data-smart-addons]')) continue;
        if (form.querySelector('[name="id"]')) return form;
      }
      return null;
    }

    function getMainFormItem(form) {
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      return {
        id: parseInt(idInput.value, 10),
        quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1
      };
    }

    function postCartAddDirect(items) {
      skipAddonMergeOnce = true;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error((err && err.description) || 'Could not add item(s) to cart.');
          });
        }
        return res.json();
      });
    }

    var buyNowState = { isSubmitting: false };

    function setupBuyNowFallbackForRoot(root) {
      if (root.dataset.syncBuyNow !== 'true') return;
      var form = findProductForm(root);
      if (!form) return;
      var nativeBuyNow = document.querySelector(
        '.shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart'
      );
      if (!nativeBuyNow || nativeBuyNow.__smartAddonsHandled) return;
      nativeBuyNow.__smartAddonsHandled = true;

      var fallbackMode = root.dataset.buyNowFallback || 'custom_button';
      nativeBuyNow.classList.add('smart-addons__native-buy-now--hidden');
      if (fallbackMode === 'hide_native') return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'smart-addons__buy-now-fallback';
      btn.textContent = root.dataset.customBuyNowText || 'Buy Now with Add-ons';
      btn.addEventListener('click', function () {
        if (buyNowState.isSubmitting) return;
        if (hasUnavailableSelected()) {
          showError('One of the selected add-ons is no longer available and was not added.');
        }
        var mainItem = getMainFormItem(form);
        var items = [mainItem].concat(getSelectedAddonItems());
        buyNowState.isSubmitting = true;
        btn.setAttribute('disabled', 'disabled');
        postCartAddDirect(items)
          .then(function () {
            buyNowState.isSubmitting = false;
            clearAllSelections();
            window.location.href = '/checkout';
          })
          .catch(function (err) {
            buyNowState.isSubmitting = false;
            btn.removeAttribute('disabled');
            showError(err.message || 'Something went wrong adding these items to your cart.');
          });
      });
      nativeBuyNow.insertAdjacentElement('afterend', btn);
    }

    function scanAndSetupBuyNow() {
      document.querySelectorAll('[data-smart-addons]').forEach(function (root) {
        setupBuyNowFallbackForRoot(root);
      });
    }

    document.addEventListener('DOMContentLoaded', scanAndSetupBuyNow);
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      scanAndSetupBuyNow();
    }

    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function () {
        scanAndSetupBuyNow();
      });
      var startObserving = function () {
        mo.observe(document.body, { childList: true, subtree: true });
      };
      if (document.body) startObserving();
      else document.addEventListener('DOMContentLoaded', startObserving);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
